import { render } from "./configurations.vue?vue&type=template&id=fe121080"
import script from "./configurations.vue?vue&type=script&lang=js"
export * from "./configurations.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__